import { Menu, MenuButton, MenuList, MenuItem, useDisclosure, useColorModeValue } from '@chakra-ui/react';
import { BiDotsVerticalRounded } from 'react-icons/bi';
// import EditGuest from '../pages/my-estate/components/EditGuest';
// import { DeleteModal } from './DeleteModal';
import { CheckoutCodeModal } from './CheckoutCodeModal';
// import { EditProfile } from './EditProfile';
import { GuestDetailsModal } from './GuestDetailsModal';
import { useNavigate } from "react-router-dom";
import { UserProfileContext } from "../context/userProfileContext";
import { timeout } from "./utils/timeout";
import React, { useContext } from "react";
import ShareModal from "../pages/invite-guest/components/ShareModal";
import { COLORS } from "../constants/colors";

import ShareInviteLink from "../pages/invite-guest/components/ShareInviteLink";


export const Popover = (props) => {
  const navigate = useNavigate();
  const { name, phone, guestCode } = props;
  const { userProfile } = useContext(UserProfileContext);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const menuColor = useColorModeValue(COLORS.black, COLORS.white);

    const handleShareClose = () => {
      // successNotifier("Link copied successfully");
      timeout(() => navigate(`/`), 1000);
    };
    const handleShareViaWhatsapp = () => {
  const inviteMessage = `${userProfile.tenantName} is inviting you to UrbanPrime1 Estate. Please use ${guestCode} at the access point to gain access. reach me on ${userProfile.tenantPhone}. Powered by MyEstate.ng`;
    window
      .open(`whatsapp://send?text=${inviteMessage}`, "_blank")
      .then(handleShareClose);
  };
  return (
    <Menu>
      <MenuButton>
        <BiDotsVerticalRounded size='1.5rem' />
      </MenuButton>
      <MenuList>
        <GuestDetailsModal {...props} />
        <MenuItem
                  onClick={() =>
                    navigate(`/invite-guest?name=${name}&phone=${phone}`)
                  }
                  color={menuColor}
                >
                  Re-invite Guest
                </MenuItem>
                <MenuItem onClick={onOpen} color={menuColor}>
                  Re-share Code
                </MenuItem>
        {/* <DeleteModal {...props} /> */}
        <CheckoutCodeModal {...props} />
      </MenuList>
      <ShareModal
        size="xs"
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={handleShareClose}
      >
        <ShareInviteLink onClose={onClose} guestCode={guestCode} />
      </ShareModal>
    </Menu>
  );
};